import React, { useState } from 'react';
import { LinearProgress } from '@mui/material';
import { useSnackbar } from 'material-ui-snackbar-provider';

import { getComposersThunk } from '../../../../store/composers/composersSlice';
import { ContainedButton, OutlinedButton } from '../../../modules/Buttons';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { deleteComposer } from '../../../../api';
import { NOTIFICATION } from '../../../../enums/ENUMS';
import Modal from '../../../modules/Modal';
import styles from './DeleteComposerAdditional.module.scss';
import { useHotkeys } from 'react-hotkeys-hook';
import { useHistory } from 'react-router-dom';
import { PATHS } from '../../../../enums';

type TDeleteComposerAdditional = {
  composerId: string;
  open: boolean;
  switchModal: () => void;
};

const DeleteComposerAdditional: React.FC<TDeleteComposerAdditional> = ({ composerId, open, switchModal }) => {
  const notification = useSnackbar();
  const dispatch = useAppDispatch();
  const { page, limit, sort, sortOption } = useAppSelector((state) => state.composersStore);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const handleDelete = async () => {
    setLoading(true);
    try {
      await deleteComposer({ composerId });
      setTimeout(() => {
        history.replace(PATHS.MY_REFLEX_COMPOSERS.path);
      }, 1000);
      switchModal();
      dispatch(getComposersThunk({ page, limit, sort, sortOption }));
    } catch (err) {
      console.log(err);
      // @ts-ignore
      if (err?.response?.data?.message) {
        // @ts-ignore
        notification.showMessage(err?.response?.data?.message);
      } else {
        notification.showMessage(NOTIFICATION.NOT_DELETED);
      }
    } finally {
      setLoading(false);
    }
  };

  useHotkeys('Enter', () => {
    if (open && !loading) {
      handleDelete();
    }
  });

  return (
    <Modal open={open} onClose={switchModal} loading={loading}>
      <div className={styles.modalBody}>
        <div className={styles.modalTitle}>Do you want to delete this composer or leave it as empty template?</div>
        <div className={styles.form} onSubmit={handleDelete}>
          <div className={styles.actionBtns}>
            <ContainedButton type="submit" kind="red" disabled={loading} onClick={handleDelete}>
              Delete composer
            </ContainedButton>
            <OutlinedButton kind="purple" type="button" disabled={loading} onClick={switchModal}>
              Leave it as empty template
            </OutlinedButton>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteComposerAdditional;
